module.exports = "/src/views/player/help/images/interior3.jpg";